import '../styles/main.scss';
import device from 'current-device';

import Splide from '@splidejs/splide';
import { URLHash } from '@splidejs/splide-extension-url-hash';
import { Video } from '@splidejs/splide-extension-video';

// Components
import './components/navigation.js';
import './components/input.js';
import './components/menu-icon.js';
import './components/store-tag.js';
import './components/search.js';
import './components/filter.js';
import './components/search-product.js';
import './components/tooltip.js';
import './sections/faq.js';
import './components/store.js';
import './components/eyeglasses-popup.js';
import './components/video-popup.js';
import './components/single-product.js';
import './components/nearest-stores.js';
import './components/product-card.js';

// Midsummer lottery 2024
import './components/midsummer-lottery.js';

// New pages
import './components/oma-files-filter.js';
import './components/oma-files.js';
import './components/dynamic-pages.js';

// Sections
import './sections/hero-banner.js';
import './sections/carousel.js';
import './sections/frame-carousel.js';
import './sections/hero-banner-academy.js';

// Players (video.js) only on pages that have one: every player that
// components/video.js starts has an id beginning with "video-". video.js used
// to be well over half of the JavaScript every page downloaded.
if (document.querySelector('[id^="video-"]')) {
    import('./components/video.js');
}

// Exports
export { Splide, URLHash, Video };
